//prodUrl: 正式环境的地址
let prodUrl = '/richin/prod';
//let prodUrl = 'http://139.159.246.231:8088';

export { prodUrl };
